import React, { MouseEvent } from "react";
import { Box, Link } from "@vp/swan";
import { useTranslation } from "../../useTranslation";

import { Screens } from "../ScreensLayout";
import { pushDataToSegment } from "../../segmentData";
import { FORGET_PASSWORD_LABEL, FORGET_PASSWORD_LINK_CLICKED, NAVIGATION_CLICKED, SIGN_IN_PAGE } from "../../constant";

interface ResetScreenLinkProps {
  onChangeScreen: (screen: Screens) => void;
}

export const ResetScreenLinkControl: React.FunctionComponent<ResetScreenLinkProps> = (
  props: ResetScreenLinkProps
) => {
  const [t] = useTranslation("reset");
  const { onChangeScreen } = props;

  const forgottenPasswordClick = (e: MouseEvent): void => {
    e.preventDefault();
    pushDataToSegment(NAVIGATION_CLICKED, false, { label: FORGET_PASSWORD_LABEL, eventDetail: SIGN_IN_PAGE, navigationDetail: FORGET_PASSWORD_LINK_CLICKED, pageName: SIGN_IN_PAGE });
    onChangeScreen(Screens.Reset);
  };

  return (
    <Box mb="between-subsections">
      <Link
        href="/#"
        onClick={forgottenPasswordClick}
        data-testid="forgottenPassword"
      >
        {t("forgottenPassword")}
      </Link>
    </Box>
  );
};

const ResetScreenLink: React.FunctionComponent<ResetScreenLinkProps> = React.memo(
  ResetScreenLinkControl
);
export default ResetScreenLink;
